"use client";

import { useQuery } from "@tanstack/react-query";
import { client } from "@/sanity/lib/client";
import groq from "groq";
import { QUERY_KEYS } from "../_lib/constants";
import type { SocialMediaQueryResult, CompanyQueryResult } from "@/sanity.types";

export function useSocialMediaData() {
	const {
		data: socialMedia,
		isLoading,
		isError,
		error,
	} = useQuery({
		queryKey: [QUERY_KEYS.socialMediaOrder],
		queryFn: async () => {
			const socialMediaQuery = groq`*[_type == "socialMediaOrder"][0]{socialMediaListOrder[]->{_id, name, link}}`;

			const result = await client.fetch<NonNullable<SocialMediaQueryResult>>(socialMediaQuery);
			return result.socialMediaListOrder;
		},
		networkMode: "always",
	});

	return {
		socialMedia: socialMedia || [],
		isLoading,
		isError,
		error,
	};
}

export function useCompanyData() {
	const {
		data: companyInfo,
		isLoading,
		isError,
		error,
	} = useQuery({
		queryKey: [QUERY_KEYS.companyInfo],
		queryFn: async () => {
			const companyQuery = groq`*[_type == "companyInfo"][0]{phoneNumber, email, addressContent{lineOne, lineTwo, lineThree}}`;

			const result = await client.fetch<NonNullable<CompanyQueryResult>>(companyQuery);
			return result;
		},
		networkMode: "always",
	});

	return {
		companyInfo: companyInfo || { phoneNumber: null, email: null, addressContent: null },
		isLoading,
		isError,
		error,
	};
}
